import React from 'react'
import { Link } from 'react-router-dom'

import Topbar from '@/components/Topbar'
import UniverseTabs from '@/components/UniverseTabs'
import DetailLayout from '@/components/DetailLayout'

/**
 * Universe overview — gateway to reference entities (Companies, Scenarios).
 *
 * Most users will reach individual entities by clicking through a workspace,
 * but this index gives a direct browsing surface and reinforces the section
 * structure. Sub-views (Companies, Scenarios) live under `/universe/...` and
 * always render the {@link UniverseTabs} bar above their content.
 */
export default function Universe() {
  return (
    <div className="container">
      <Topbar subtitle="Universe" />
      <UniverseTabs />

      <DetailLayout>
        <DetailLayout.Hero
          kicker="Universe"
          title="Reference entities"
          subtitle="Companies and scenarios that appear inside your workspaces. Open a workspace to forecast against a question; jump in here to browse directly."
        />
        <DetailLayout.Section
          id="universe-companies"
          title={
            <div className="row" style={{ justifyContent: 'space-between', alignItems: 'baseline' }}>
              <span>Companies</span>
              <Link className="btn" to="/universe/companies">Browse companies</Link>
            </div>
          }
        >
          <div className="muted" style={{ fontSize: 13, lineHeight: 1.5 }}>
            Tracked companies, posture, memos, and forecast review. Used as entity context inside
            workspaces.
          </div>
        </DetailLayout.Section>
        <DetailLayout.Section
          id="universe-scenarios"
          title={
            <div className="row" style={{ justifyContent: 'space-between', alignItems: 'baseline' }}>
              <span>Scenarios</span>
              <Link className="btn" to="/universe/scenarios">Browse scenarios</Link>
            </div>
          }
        >
          <div className="muted" style={{ fontSize: 13, lineHeight: 1.5 }}>
            Reusable conditional frames (bull/base/bear, branching outcomes) that workspaces and
            forecasts can be evaluated against.
          </div>
        </DetailLayout.Section>
      </DetailLayout>
    </div>
  )
}
